import styled from 'styled-components';

export const Image = styled.img`
  height: 100px;
  margin: 30px;
  display: inline-block;
`;